import React, { useEffect, useMemo, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { useSelector } from 'react-redux';
import Select from 'react-select';
import ActiveHelper from '../../../components/common/activeHelper';
import { accessTypes } from '../../../helpers/Utils';
import { Colxx } from '../../../components/common/CustomBootstrap';

const UpSelling = ({ match }) => {
  const { user } = useSelector(state => state.authUser);
  const search = useSelector(state => state.settings.search) || '';
  const { activeItem } = useSelector(state => state.activeItem);
  const { up_selling } = useSelector(state => state.providers);
  const { modifiers, provider } = useSelector(state => state.providers);

  // State for dynamic filters
  const [filters, setFilters] = useState({});
  const [filteredUpSelling, setFilteredUpSelling] = useState([]);

  // Local filtering logic
  useEffect(() => {
    let filtered = Object.values(up_selling || {});

    // Filter by service provider - single select
    if (filters?.sp_id?.key) {
      filtered = filtered.filter(item => item.sp_id === filters.sp_id.key);
    }

    // Search filter - search across name, arabic name, type, and provider name
    if (search && search.trim()) {
      const searchLower = search.toLowerCase().trim();
      filtered = filtered.filter(item => {
        const nameMatch = (item?.name?.en || item?.name || '')?.toLowerCase().includes(searchLower);
        const nameArMatch = (item?.name_ar?.en || item?.name_ar || '')?.toLowerCase().includes(searchLower);
        const typeMatch = item?.type?.toLowerCase().includes(searchLower);
        const providerMatch = provider?.[item?.sp_id]?.name?.toLowerCase().includes(searchLower);
        return nameMatch || nameArMatch || typeMatch || providerMatch;
      });
    }

    setFilteredUpSelling(filtered);
  }, [filters, up_selling, search, provider]);

  const elements = useMemo(() => {
    // Check both possible paths for the type field to ensure compatibility
    const itemType = activeItem?.general?.type || activeItem?.type;

    return [{
      key: 'generalInfo',
      title: 'General Information',
      data: [
        { key: 'img', title: 'Image', width: '10', type: 'picture', dimensions: { width: 1080, height: 1440 } },
        { key: 'name', title: 'Name', width: '10', type: 'text' },
        { key: 'name_ar', title: 'Arabic Name', width: '10', type: 'text' },
        {
          key: 'type', title: 'Select Type', width: '10', data: [
            { name: 'Service', key: 'Service', id: 'Service' },
            { name: 'Product', key: 'Product', id: 'Product' },
          ], type: 'select'
        },
        { key: 'price', title: 'Price (AED)', width: '10', type: 'number', hide: itemType !== 'Product' },
        { key: 'price', title: 'Modifiers', width: '10', data: Object.values(modifiers || {}) || [], type: 'modifier-config', selected: 'conditions', hide: itemType === 'Product' },
        { key: 'sp_id', title: 'Service Provider', width: '10', data: Object.values(provider || {})?.map(rec => { return { ...rec, name: rec.name, key: rec.key, id: rec.key } }) || [], type: 'select', selected: 'providers', },
      ]
    }];
  }, [activeItem?.general?.type, activeItem?.type, modifiers, provider]);

  const tableColumns = useMemo(() => {
    return [
      { Header: "Status", accessor: "active", width: 120, type: 'switch', },
      { Header: "", accessor: "img", width: 100, type: 'img', },
      { Header: "Name", accessor: "name", width: 150, type: 'label' },
      { Header: "Arabic Name", accessor: "name_ar", width: 150, type: 'label' },
      { Header: "Service Provider", accessor: "sp_id", width: 150, type: 'provider', show: accessTypes.includes(user?.accessType) },
      { Header: "Type", accessor: "type", width: 150, type: 'label' },
      { Header: "Price", accessor: "price", type: 'modifier' },
      { Header: 'Created', accessor: 'created', type: 'date' },

    ];
  }, [user?.accessType]);

  // Create filter component for service provider selection
  const filterComponent = useMemo(() => {
    if (!accessTypes.includes(user?.accessType)) {
      return null;
    }

    const providerOptions = Object.values(provider || {});

    return (
      <Colxx xxs="12" md="3" className='mb-3' >
        <Select
          isClearable={true}
          placeholder="Filter by Service Providers"
          name="sp_id"
          options={providerOptions}
          className="basic-multi-select"
          classNamePrefix="select"
          value={filters?.sp_id || undefined}
          onChange={val => setFilters(prev => ({ ...prev, sp_id: val || undefined }))}
        />
      </Colxx>
    );
  }, [provider, user?.accessType, filters]);

  return (
    < div >
      <Switch>
        {/* <Route path={`${match.url}/`} component={WashersList} /> */}
        <Route path={`${match.url}`} render={() => (
          <ActiveHelper
            data={filteredUpSelling || []}
            title="Up Selling"
            selected='up_selling'
            elements={elements}
            tableColumns={tableColumns}
            permenatDelete={true}
            filters={filters}
            filterComponent={filterComponent}
            showCreateButton={true}
          />
        )} />

        <Redirect to="/error" />
      </Switch>
    </div >
  )

};
export default UpSelling;
